import * as actionTypes from '../constants/index';
const projectInfo = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.SET_PROJECTINFO:
			return action.data;
		default:
			return state;
	}
};
export { projectInfo }